import React, { useMemo, useEffect } from 'react';
import { Box, Fab, FormHelperText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useSelector, useLocation } from 'umi';
import { useDispatch } from 'dva';
import { Controller } from 'react-hook-form';
import ArchiveIcon from '@material-ui/icons/Archive';
import XLSX from 'xlsx';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import webStorage from '@/utils/storageManager';
import request from '@/utils/request';
import {
  SelectFieldCom,
  TextFieldCom,
  RadioFieldCom,
} from '../../../profile/label_manage/components/FormType';
import { CheckBoxFieldCom } from '@/components/FormType';
import { getToken } from '@/utils/token';

const typeListRadios = [
  { label: '手动写入', value: '1' },
  { label: '批量导入', value: '2' },
];

export default ({
  control,
  setValue,
  getValues,
  errors,
  setError,
  clearErrors,
  watch,
  setFileList,
  fileList,
}) => {
  const {
    qrParamsFormData,
    refreshQrParamsFormData,
    refreshPagePath,
    defaultFormData,
  } = useSelector((state) => state.miniQrCode);
  const dispatch = useDispatch();
  const location = useLocation();
  const { query } = location;
  const { queryType } = query;
  const miniProgramAccountList =
    useSelector((state) => state.addAutoReplyRule.miniProgramAccountList) || [];
  const watchChannel = watch('channelList');
  const watchPagePath = watch('pagePath');
  const watchCreateType = watch('createType');
  const { MINI_CODE_CHANNEL } = webStorage.get('DICTOBJ') || {};
  //生成唯一id
  function guid() {
    return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
      36,
    );
  }
  //点击添加一条小程序码参数
  const handleOperationParamData = (index, status) => {
    dispatch({
      type: 'miniQrCode/operationParamData',
      payload: {
        values: {
          index,
          status,
        },
      },
    });
  };
  //参数输入修改数据结果
  const handleInitEvent = (params) => {
    dispatch({
      type: 'miniQrCode/setParamData',
      payload: {
        values: params,
      },
    });
  };

  useEffect(() => {
    if (
      qrParamsFormData &&
      qrParamsFormData.length > 0 &&
      refreshQrParamsFormData
    ) {
      qrParamsFormData.map((item) => {
        setValue(`name_${item.id}`, item.name);
        setValue(`value_${item.id}`, item.value);
      });
    }
  }, [qrParamsFormData?.length, setValue, refreshQrParamsFormData]);

  const paramsStr = useMemo(() => {
    if (qrParamsFormData && qrParamsFormData.length > 0) {
      let params = '';
      qrParamsFormData.map((item, index) => {
        if (item.name && item.value) {
          if (index === 0) {
            params = item.name + '=' + item.value;
          } else {
            params += '&' + item.name + '=' + item.value;
          }
        }
      });
      return params;
    }
  }, [qrParamsFormData?.length, refreshPagePath, refreshQrParamsFormData]);
  useEffect(() => {
    if (defaultFormData) {
      setValue('name', defaultFormData.name);
      setValue('appId', defaultFormData.appId);
      setValue('pagePath', defaultFormData.pagePath);
      setValue('showLogo', defaultFormData.showLogo);
      setValue('channelList', defaultFormData.channelList);
      setValue('storeKey', defaultFormData.storeKey);
      setValue('createType', String(defaultFormData.createType));
      defaultFormData.importUrl &&
        setFileList([
          {
            url: defaultFormData.importUrl,
            id: guid(),
            fileName: defaultFormData.importUrl,
          },
        ]);
      defaultFormData.importUrl && setValue('url', defaultFormData.importUrl);
    } else {
      setValue('createType', '1');
    }
  }, [defaultFormData]);
  const storeStr = useMemo(() => {
    if (paramsStr) {
      return watchChannel?.length > 0 ? '&channel=XXX' : '';
    }
    return watchChannel?.length > 0 ? '?channel=XXX' : '';
  }, [watchChannel, paramsStr]);
  const clearArrayData = (params) => {
    dispatch({
      type: 'miniQrCode/clearOperationParamData',
      payload: {
        values: params,
      },
    });
  };

  // 下载模版
  const handleClickDownload = () => {
    if (queryType === 'detail') {
      return;
    }
    const url = 'QRCODE_ZIP/小程序码批量导入模板_202507141054007585.xlsx';
    console.log(111, `${process.env.FILE_URL}/${url}`);
    let aLink = document.createElement('a');
    aLink.download = 'ExternalTagBlankTamplate.xlsx'; //文件名随意
    aLink.href = `${process.env.FILE_URL}/${url}`;
    aLink.click();
    aLink.remove();
  };

  // 上传文件
  const uploadFile = (formData, fileName) => {
    if (queryType !== 'detail') {
      request('/common/upload', {
        method: 'POST',
        data: formData,
      })
        .then((res) => {
          if (res.code === 0) {
            const fileObj = { id: guid(), ...res.data, fileName };
            setFileList([fileObj]);
            document.getElementById('inputFile').value = null;
            setValue('url', JSON.stringify(fileList));
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: '失败',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  //删除文件
  const handleFileListDelete = ({ selfId }) => {
    const list = fileList.filter((item) => item.id !== selfId);
    setFileList([...list]);
    setValue('url', list.length > 0 ? JSON.stringify(list) : '');
  };

  const getFileName = (str) => {
    console.log({ str });
    const startIndex = str.indexOf('/') + 1;
    const endIndex = str.lastIndexOf('_');
    const middleContent = str.substring(startIndex, endIndex);

    // 拼接点号后面的内容
    const dotIndex = str.lastIndexOf('.') + 1;
    const extension = str.substring(dotIndex);
    if (!middleContent) {
      return str;
    }
    const result = middleContent + '.' + extension;
    return result;
  };

  //下载文件
  const handleDownloadUrl = ({ selfId }) => {
    fileList.forEach((item) => {
      if (item.id === selfId) {
        const apiToken = `${getToken()}`;
        const a = document.createElement('a');
        a.download = item.fileName;
        a.href = `${
          window.location.origin
        }/bizgrowth/web/v1/common/download?uri=${encodeURIComponent(
          item.url,
        )}&access_token=${apiToken}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    });
  };
  return (
    <Box display="flex" flexDirection="column" gap="32px 0">
      <Box display="flex" gap="24px" flexDirection="column">
        <Box width="320px">
          <TextFieldCom
            label="小程序码组名称"
            control={control}
            name="name"
            setValue={setValue}
            getValues={getValues}
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
              maxLength: 50,
            }}
            errors={errors}
            queryType={queryType}
          />
        </Box>
        <Box width="320px" display="flex" alignItems="flex-end">
          <SelectFieldCom
            label="小程序"
            initLabel={true}
            // placeholder="请选择小程序"
            name="appId"
            realName="operation"
            disabled={queryType === 'detail'}
            setValue={setValue}
            control={control}
            errors={errors}
            setError={setError}
            clearErrors={clearErrors}
            nameMessage=""
            typeList={miniProgramAccountList || []}
            fieldNames={{ label: 'nickName', value: 'appId' }}
          />
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            color: '#212121',
            fontSize: '18px',
            fontWeight: '600',
          }}
        >
          小程序码参数
        </Box>
        <Box display="flex" flexDirection="column" gap="24px">
          <Box width="320px">
            <TextFieldCom
              label="PagePath"
              control={control}
              name="pagePath"
              setValue={setValue}
              getValues={getValues}
              placeholder="请输入"
              rules={{
                required: true, //是否是必填项true 必填 false 非必填
                maxLength: 200,
                pattern: /^[a-zA-Z0-9_/!@#$%^&*(),.?":{}|<>+-=]+$/,
              }}
              errors={errors}
              queryType={queryType}
              helperText="仅可输入数字、英文、英文符号"
            />
          </Box>
          <Box display="flex" alignItems="center">
            <RadioFieldCom
              name="createType"
              control={control}
              typeList={typeListRadios}
              lWidth="auto"
              // initLabel={true}
              label=""
              // defaultVal="1"
              queryType={queryType}
            />
            <Box
              sx={{
                fontSize: '12px',
                color: '#999',
                lineHeight: '17px',
                marginLeft: '-8px',
              }}
            >
              每一列为一个字段，第一行为字段名称，第二行开始为对应字段值
            </Box>
          </Box>
          <Box
            sx={{
              display: watchCreateType === '1' ? 'flex' : 'none',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <Box
              sx={{
                background: '#F9F9F9',
                borderRadius: '8px',
                padding: '12px 16px',
              }}
            >
              <span
                style={{
                  color: '#999999',
                  fontSize: '16px',
                  lineHeight: '20px',
                  marginRight: '8px',
                }}
              >
                预览
              </span>
              {
                <span
                  style={{
                    color: queryType !== 'detail' ? '#333333' : '#ccc',
                    fontSize: '14px',
                    wordBreak: 'break-all',
                  }}
                >
                  {watchPagePath || (
                    <span style={{ color: '#cccccc', fontSize: '14px' }}>
                      pagepath
                    </span>
                  )}
                  {paramsStr ? (
                    `?${paramsStr}`
                  ) : (
                    <span
                      style={{
                        color: '#ccc',
                        fontSize: '16px',
                        lineHeight: '22px',
                      }}
                    >
                      {storeStr ? '' : '?参数名称=参数内容&渠道参数名称=XXXXX'}
                    </span>
                  )}
                  <span
                    style={{
                      color: queryType !== 'detail' ? '#333333' : '#ccc',
                      fontSize: '14px',
                    }}
                  >
                    {storeStr}
                  </span>
                </span>
              }
            </Box>
            <Box
              border=" 1px solid #CCCCCC"
              borderRadius="12px"
              // width="1096px"
              padding="25px 48px 24px 24px"
              display="flex"
              flexDirection="column"
              gap="25px 0"
            >
              {qrParamsFormData &&
                qrParamsFormData.length > 0 &&
                qrParamsFormData.map((item, index) => (
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    key={item.id}
                  >
                    <Box display="flex" gap="0 48px">
                      <Box width="420px">
                        <TextFieldCom
                          label="参数名称"
                          control={control}
                          name={`name_${item.id}`}
                          setValue={setValue}
                          placeholder="输入文本"
                          // defaultValue={item.name}
                          handleInitEvent={(v) =>
                            handleInitEvent({ index, key: 'name', value: v })
                          }
                          clearArrayData={clearArrayData}
                          parameter={{
                            index,
                            key: 'name',
                          }}
                          queryType={queryType}
                          errors={errors}
                          rules={
                            watchCreateType === '1'
                              ? {
                                  maxLength: 30,
                                  pattern:
                                    /^[a-zA-Z0-9_/!@#$%^&*(),.?":{}|<>+-=]+$/,
                                }
                              : {}
                          }
                          helperText="仅可输入数字、英文、英文符号"
                        />
                      </Box>
                      <Box width="420px">
                        <TextFieldCom
                          label="参数内容"
                          control={control}
                          name={`value_${item.id}`}
                          setValue={setValue}
                          placeholder="输入文本"
                          // defaultValue={item.value}
                          handleInitEvent={(v) =>
                            handleInitEvent({ index, key: 'value', value: v })
                          }
                          errors={errors}
                          clearArrayData={clearArrayData}
                          parameter={{
                            index,
                            key: 'value',
                          }}
                          queryType={queryType}
                          rules={
                            watchCreateType === '1'
                              ? {
                                  maxLength: 30,
                                  pattern:
                                    /^[a-zA-Z0-9_/!@#$%^&*(),.?":{}|<>+-=]+$/,
                                }
                              : {}
                          }
                          helperText="仅可输入数字、英文、英文符号"
                        />
                      </Box>
                    </Box>
                    <Box display="flex" gap="0 16px" alignItems="flex-end">
                      {qrParamsFormData?.length < 5 && (
                        <Box className="params-icon-wrap">
                          <AddIcon
                            width="100%"
                            height="100%"
                            htmlColor={
                              queryType === 'detail'
                                ? 'rgba(0, 0, 0, 0.38)'
                                : 'rgba(0, 0, 0, 0.87)'
                            }
                            onClick={() =>
                              queryType !== 'detail' &&
                              handleOperationParamData(index, '1')
                            }
                          />
                        </Box>
                      )}
                      {qrParamsFormData?.length > 1 && (
                        <Box className="params-icon-wrap">
                          <RemoveIcon
                            width="100%"
                            height="100%"
                            htmlColor={
                              queryType === 'detail'
                                ? 'rgba(0, 0, 0, 0.38)'
                                : 'rgba(0, 0, 0, 0.87)'
                            }
                            onClick={() =>
                              queryType !== 'detail' &&
                              handleOperationParamData(index, '0')
                            }
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                ))}
            </Box>
            <CheckBoxFieldCom
              control={control}
              name="channelList"
              checkedBoxList={MINI_CODE_CHANNEL}
              setValue={setValue}
              getValues={getValues}
              disabled={queryType === 'detail'}
              label={
                <span style={{ fontSize: '14px', color: '#212100' }}>
                  渠道参数{' '}
                  <span style={{ fontSize: '12px', color: '#666' }}>
                    选择渠道，生成渠道下带参数链接和太阳码
                  </span>
                </span>
              }
              initLabel
              fieldNames={{ label: 'nameZh', value: 'dictCode' }}
              style={{ display: 'flex', flexDirection: 'row' }}
            />
          </Box>
          <Box sx={{ display: watchCreateType !== '1' ? 'block' : 'none' }}>
            <div className="export-wrapper" style={{ marginTop: 12 }}>
              <Fab
                variant="extended"
                size="small"
                color={queryType === 'detail' ? '#fff' : 'primary'}
                aria-label="add"
                className="download"
                sx={{ mr: 1.6 }}
                onClick={handleClickDownload}
                disabled={queryType === 'detail' ? 'disabled' : null}
              >
                <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
                下载样例
              </Fab>
              <Fab
                variant="extended"
                size="small"
                color={queryType === 'detail' ? '#fff' : 'primary'}
                aria-label="add"
                className="uploadFile"
                sx={{ position: 'relative' }}
                disabled={queryType === 'detail' ? 'disabled' : null}
              >
                <Controller
                  render={(rp) => {
                    return (
                      <input
                        className="fileInput"
                        name="url"
                        style={{
                          position: 'absolute',
                          left: '0px',
                          top: '0px',
                          opacity: 0,
                        }}
                        disabled={queryType === 'detail'}
                        type="file"
                        id="inputFile"
                        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        label="上传文件"
                        onChange={(e) => {
                          // setFileName(e.target.value); //"C:\fakepath\MemberBlackTemplate.csv"
                          let file = e.target.files;
                          let formData = new FormData(); //{}
                          const fileName = file[0].name; //文件名 MemberBlackTemplate.csv
                          if (file) {
                            const reader = new FileReader();
                            reader.readAsBinaryString(file[0]);
                            reader.onload = function (ed) {
                              try {
                                const data = ed.target.result;
                                const workbook = XLSX.read(data, {
                                  type: 'binary',
                                });
                                const sheetName = workbook.SheetNames[0];
                                const worksheet = workbook.Sheets[sheetName];
                                const range = XLSX.utils.decode_range(
                                  worksheet['!ref'],
                                );
                                const rowCount = range.e.r + 1;
                                if (!rowCount || rowCount < 2) {
                                  window.message.toast({
                                    type: 'error',
                                    message: '上传的文件中没有数据',
                                    title: '',
                                  });
                                  document.getElementById('inputFile').value =
                                    null;
                                  return;
                                }
                                formData.append('file', file[0]);
                                formData.append('isFixedName', true);
                                formData.append('isPublic', false);
                                formData.append('bucket', 'QRCODE_ZIP');
                                uploadFile(formData, fileName);
                              } catch (error) {
                                formData.append('file', file[0]);
                                formData.append('isFixedName', true);
                                formData.append('isPublic', false);
                                formData.append('bucket', 'QRCODE_ZIP');
                                uploadFile(formData, fileName);
                              }
                            };
                          }
                          return rp.onChange(e);
                        }}
                      />
                    );
                  }}
                  name="url"
                  type="file"
                  label="上传文件"
                  control={control}
                  rules={{ required: watchCreateType !== '1' }}
                />
                <UnarchiveIcon sx={{ width: '24px', height: '24px' }} />
                上传文件
              </Fab>
              <FormHelperText
                error={Boolean(errors.url)}
                sx={{ marginTop: '8px' }}
              >
                {Boolean(errors?.url?.type === 'required') &&
                  '若选择批量导入则上传文件为必填项'}
              </FormHelperText>
            </div>
            {fileList &&
              fileList.map((item) => {
                return (
                  <Box
                    className="file_name"
                    mt={2.6}
                    style={{
                      color: '##1565c0',
                    }}
                    key={item.id}
                  >
                    <span
                      style={{
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        handleDownloadUrl({ selfId: item.id });
                      }}
                    >
                      {item.fileName && getFileName(item.fileName)}
                    </span>
                    {queryType === 'detail' ? (
                      ''
                    ) : (
                      <HighlightOffIcon
                        sx={{
                          width: '24px',
                          height: '24px',
                          color: 'rgba(0, 0, 0, 0.26)',
                          marginLeft: '9px',
                          cursor: 'pointer',
                          verticalAlign: 'middle',
                        }}
                        key={item.id}
                        onClick={() => {
                          handleFileListDelete({ selfId: item.id });
                        }}
                      />
                    )}
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
